
// Helper function to determine shift parameters based on type
function getShiftParams(type) {
  switch (type) {
    case 'day':
      return { addUnit: 'day', multiplier: 1 };
    case 'week':
      return { addUnit: 'week', multiplier: 1 };
    case 'month':
      return { addUnit: 'month', multiplier: 1 };
    case 'quarter':
      return { addUnit: 'month', multiplier: 3 };
    case 'year':
      return { addUnit: 'year', multiplier: 1 };
    default:
      return { addUnit: 'day', multiplier: 1 };
  }
}

// Helper function to calculate the start of a period based on type
function getPeriodStart(date, type) {
  switch (type) {
    case 'day':
      return date;
    case 'week':
      return date.startOf('isoWeek');
    case 'month':
      return date.startOf('month');
    case 'quarter':
      const quarter = Math.floor(date.month() / 3);
      const startMonth = quarter * 3;
      return date.month(startMonth).startOf('month');
    case 'year':
      return date.startOf('year');
    default:
      return date;
  }
}

// Helper function to calculate the end of a period based on type
function getPeriodEnd(date, type) {
  switch (type) {
    case 'day':
      return date;
    case 'week':
      return date.endOf('isoWeek');
    case 'month':
      return date.endOf('month');
    case 'quarter':
      const quarter = Math.floor(date.month() / 3);
      const endMonth = quarter * 3 + 2;
      return date.month(endMonth).endOf('month');
    case 'year':
      return date.endOf('year');
    default:
      return date;
  }
}

// 根据偏移量计算日期范围
function getDateRange(type, offset, today) {
  
  const { addUnit, multiplier } = getShiftParams(type);
  // 确保添加偏移量后仍保留时区信息
  const refDate = today.add(offset * multiplier, addUnit);
  
  const startDate = getPeriodStart(refDate, type);
  
  let endDate;
  if (offset === 0) {
    endDate = today;
  } else {
    endDate = getPeriodEnd(refDate, type);
  }
  
  // 明确确保返回的日期对象保留时区信息
  return [startDate, endDate];
}

export { getDateRange };
